import React from "react";
import InfoDialog from "../../components/InfoDialog.tsx"; 

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ManualChoiceInfoDialog: React.FC<Props> = ({ open, onClose }) => (
  <InfoDialog
    open={open}
    onClose={onClose}
    title="Nutzereingabe mit Bestätigung"
    text={`Mit der Nutzereingabe kann Feedback vom Tester eingeholt werden, welches nicht mit der Prüfelektronik geprüft werden kann. Die Frage sollte immer geschlossen formuliert werden, sodass Tester eindeutig mit "Pass" oder "Fail" antworten können.
        Der Tester muss zwingend eine der beiden Optionen "Pass" oder "Fail" auswählen und kann dann den Dialog schließen.
        Eine Maus ist für die Bedienung zwingend erforderlich.`
    }
    imageSrc="/testprocedere/ManualChoice.png"
  />
);